module.exports = __webpack_public_path__ + "img/studio.8887e14d.jpg";